import store from 'store/store';
const callback = (newValue, oldValue) => {
    store.previousHeaderVariants.set(oldValue.length ? oldValue : newValue);
};
store.headerVariants.listen(callback);
